export const disableWheelChange = (e: React.WheelEvent<HTMLInputElement>) => {
	e.currentTarget.blur(); // prevents scroll-changing the value
};
